import React, { useContext } from "react";
import type { DateRangeAction } from "./useDateRange";
import { DateRangeActionType } from "./useDateRange";

const ActionContext = React.createContext<
  React.Dispatch<DateRangeAction> | undefined
>(undefined);

export type ActionProviderProps = React.PropsWithChildren<{
  value: React.Dispatch<DateRangeAction>;
}>;

export const ActionProvider = ({
  value,
  children,
}: ActionProviderProps): JSX.Element => {
  return (
    <ActionContext.Provider value={value}>{children}</ActionContext.Provider>
  );
};

export const useDateRangeAction = (): React.Dispatch<DateRangeAction> => {
  const dispatch = useContext(ActionContext);

  if (dispatch === undefined) {
    throw new Error("ActionContext must be used within an ActionProvider");
  }

  return dispatch;
};

export { DateRangeActionType };
